module.exports = __webpack_public_path__ + "img/logo.c35972fd.svg";